import { useState } from "react";
import AllPayments from "./schedule_payment/AllPayments";
import MonthlyInputs from "./schedule_payment/MonthlyInputs";

// Sub-tabs of the Schedule Payment view, in display order.
const TAB_OPTIONS = [
  { key: "allPayments", label: "All Payments" },
  { key: "monthlyInputs", label: "Monthly Inputs" },
];

/**
 * Schedule Payment shell: renders the sub-tab bar and delegates to the tab
 * components. It holds NO data-fetching or filter state of its own — each tab
 * owns that — so the two can diverge without either constraining the other.
 *
 * Props pass straight through, unchanged, to whichever tab is active. Both
 * host pages keep the same call signature they had before the split:
 *   AccessClinicCashFlow → <SchedulePayment />                 (clinic mode)
 *   DensNDenteCashFlow   → <SchedulePayment entityIds={...} /> (entity mode)
 */
export default function SchedulePayment(props) {
  const [activeTab, setActiveTab] = useState(TAB_OPTIONS[0].key);

  return (
    <>
      <div className="mb-6 flex gap-1 border-b border-palette-slate-divider">
        {TAB_OPTIONS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActiveTab(t.key)}
            className={`-mb-px border-b-2 px-3 py-1.5 text-sm font-medium transition-colors ${
              activeTab === t.key
                ? "border-palette-indigo-label text-palette-indigo-badge"
                : "border-transparent text-palette-slate-secondary hover:text-palette-slate-heading"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {activeTab === "monthlyInputs" ? <MonthlyInputs {...props} /> : <AllPayments {...props} />}
    </>
  );
}
